module.exports = __webpack_public_path__ + "static/media/ope_heidi_768x960.3cae07c8.jpg";